import { render, staticRenderFns } from "./SupervisedProjectsView.vue?vue&type=template&id=cd3936ca&scoped=true&"
import script from "./SupervisedProjectsView.vue?vue&type=script&lang=js&"
export * from "./SupervisedProjectsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd3936ca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
installComponents(component, {VCard,VIcon,VSpacer,VToolbar,VToolbarTitle})
